/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import moment from 'moment/moment';
import { Timeframe } from '../../models/enums/Timeframe';

// State
interface ParkingTransactionState {
  customTimeframeFilter: CustomTimeframeFilter;
}

const initialState: ParkingTransactionState = {
  customTimeframeFilter: {
    timeframe: Timeframe.Today,
    customStartDate: moment().toISOString(),
    customEndDate: moment().hours(23).minutes(59).toISOString(),
  },
};

export interface CustomTimeframeFilter {
  timeframe: Timeframe;
  customStartDate: string;
  customEndDate: string;
}

// Name
const storeName = '@PARKING_TRANSACTION';

// Redux Actions|Reducers
const parkingTransactionSlice = createSlice({
  name: storeName,
  initialState,
  reducers: {
    // Table TimeFrame filters
    updateTimeFrameFilter: (state, action: PayloadAction<CustomTimeframeFilter>) => {
      state.customTimeframeFilter = action.payload;
    },
  },
});

// Export Actions
export const { updateTimeFrameFilter } = parkingTransactionSlice.actions;

// Export Reducer
export default parkingTransactionSlice.reducer;
